import {
    buildConfigSlice,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import {
    initialSymbolInfoCapsuleConfigState,
    SymbolInfoCapsuleConfigState,
} from 'widgets/symbolInfo/capsule/store/config/SymbolInfoCapsuleConfigState';
import { selectSymbolInfoCapsuleState } from 'widgets/symbolInfo/capsule/store/selectors';

export const buildSymbolInfoCapsuleConfigSlice = () =>
    buildConfigSlice<SymbolInfoCapsuleConfigState>(
        WidgetType.SYMBOL_INFO_CAPSULE,
        selectSymbolInfoCapsuleState,
        initialSymbolInfoCapsuleConfigState
    );

export const useSymbolInfoCapsuleConfigSlice = () =>
    useConfigSlice(buildSymbolInfoCapsuleConfigSlice());

export type SymbolInfoCapsuleConfigPayloadType =
    WidgetConfigSliceActionPayloadType<SymbolInfoCapsuleConfigState>;
